module.exports = __webpack_public_path__ + "assets/media/1.7a981a7e.wav";